import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SlideInOutAnimation } from 'src/app/core/routes/agreements/agree-form/animations/animations';

@Component({
    selector: 'app-yes-or-no-selection',
    templateUrl: './yes-or-no-selection.component.html',
    styleUrls: ['./yes-or-no-selection.component.scss'],
    animations: [SlideInOutAnimation],
    standalone: false
})
export class YesOrNoSelectionComponent implements OnInit, ControlValueAccessor {
    private _value?: boolean;
    @Input() disabled = false;
    @Input() errorMessageTranslateKey;
    @Input() variant: 'default' | 'b' = 'default';
    onChange = (value: boolean) => {};
    onTouched = () => {};

    get value(): boolean {
        return this._value;
    }

    set value(value: boolean) {
        if (!this.disabled && this._value != value) {
            this._value = value;
            this.onChange(this.value);
        }
    }

    constructor(private translate: TranslateService, @Optional() @Self() public ngControl: NgControl) {
        if (this.ngControl != null) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngOnInit() {}

    getTranslatedErrorMessage(): string {
        return this.translate.instant(this.errorMessageTranslateKey);
    }

    writeValue(value: boolean): void {
        this.value = value;
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    yesSelected(): boolean {
        return this.value === true;
    }

    noSelected(): boolean {
        return this.value === false;
    }

    slideInOutAnimation() {
        return this.isInvalid() ? 'in' : 'out';
    }

    isInvalid() {
        return this.ngControl.touched && this.ngControl.invalid;
    }
}
